<template>
    <v-card class="pa-4" height="1000" max-width="1680">
        <v-row>
            <v-col cols="12" sm="12">
                <h3 class="subtitle-1">Tipo de conteúdo</h3>
                <div class="d-flex">

                    <v-card class="pt-3 mr-2" :color="projectType == 'estatico' ? 'primary' : ''"
                        @click="projectType = 'estatico'" width="200">
                        <div class="text-center" :class="projectType == 'estatico' ? 'white--text' : ''">
                            <v-icon size="38" :color="projectType == 'estatico' ? 'white' : ''">mdi-play-box</v-icon>
                            <p class="pb-0 pt-2 mb-0"><strong>Estático</strong></p>
                            <div class="text-caption pb-3"><strong>(Imagens e fotos)</strong></div>
                        </div>
                    </v-card>
                    <v-card class="pt-3" :color="projectType == 'dinamico' ? 'primary' : ''"
                        @click="projectType = 'dinamico'" width="200">
                        <div class="text-center" :class="projectType == 'dinamico' ? 'white--text' : ''">
                            <v-icon size="38" :color="projectType == 'dinamico' ? 'white' : ''">mdi-image</v-icon>
                            <p class="pb-0 pt-2 mb-0"><strong>Dinâmico</strong></p>
                            <div class="text-caption pb-3"><strong>(Vídeos e slides)</strong></div>
                        </div>
                    </v-card>
                    <v-spacer></v-spacer>
                    <v-btn class="mr-2" @click="view = 'builder'" x-large
                        :color="view == 'builder' ? 'primary' : ''">Construtor de
                        conteúdo</v-btn>
                    <v-btn @click="view = 'tips'" x-large :color="view == 'tips' ? 'primary' : ''">Dados do
                        template</v-btn>
                </div>

                <!-- <v-btn>mdi-image</v-btn> -->
                <!-- <v-select v-model="projectType" :items="['estatico', 'dinamico']" label="Tipo de Projeto" /> -->
            </v-col>
            <!-- <v-col cols="12" sm="6" v-if="projectType === 'dinamico'">
                <v-text-field v-model.number="videoDuration" type="number" label="Duração do vídeo (segundos)" min="1"
                    max="60" />
            </v-col> -->
        </v-row>
        <v-divider class="mt-6 mb-3"></v-divider>
        <div v-if="view == 'tips'">
            <div style="display: grid; grid-template-columns: 1fr 1px 1fr; column-gap: 15px">

                <div>
                    <h3 class="title-1">Dados do template</h3>
                    <v-text-field v-model="name" label="Título do template"></v-text-field>


                </div>

            </div>
        </div>
        <div v-if="view == 'builder'">
            <template>
                <v-card class="-grid-columns" elevation="0">

                    <!-- Templates predefinidos -->
                    <div>

                        <h3 class="subtitle-1">Templates</h3>
                        <v-card outlined class="px-2 pt-2 mb-1">


                            <div class="templates">
                                <v-card elevation="1" v-for="tpl in templates" :key="tpl.name" class="mb-2" block
                                    @click="loadTemplate(tpl)" width="120">

                                    <v-img :src="tpl.bg" width="120px"></v-img>
                                </v-card>
                            </div>
                        </v-card>

                        <h3 class="subtitle-1">Módulos</h3>
                        <v-card outlined class="px-2 py-2 mb-1">
                            <v-list dense v-if="canvasModules">
                                <v-list-item v-for="(mod, key) in canvasModules" :key="key">
                                    <v-list-item-content @click="selectModule(mod)">
                                        <v-list-item-title v-if="mod.type == 'textbox'">
                                            <v-icon>mdi-format-text</v-icon>
                                            {{ mod.obj.text }}
                                        </v-list-item-title>
                                        <v-list-item-title v-if="mod.type == 'image'">
                                            <v-icon>mdi-image-filter-hdr</v-icon>
                                            {{ mod.name }}
                                        </v-list-item-title>

                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon small @click.stop="removeModule(mod)">
                                            <v-icon color="red">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>

                            <v-divider class="my-2" v-if="canvasModules.length"></v-divider>
                            <div class="templates">
                                <v-card color="primary" block @click="addTextModule">
                                    <div class="py-2 white--text text-center"><v-icon
                                            color="white">mdi-format-text</v-icon><br>Texto</div>
                                </v-card>
                                <v-card color="primary" block @click="triggerImageUpload">
                                    <div class="py-2 white--text text-center"><v-icon
                                            color="white">mdi-image-filter-hdr</v-icon><br>Imagem</div>
                                </v-card>
                            </div>

                            <input type="file" ref="fileInput" style="display:none" @change="onImageUpload">
                        </v-card>
                    </div>

                    <!-- Canvas -->
                    <div class="pt-7">
                        <div class="d-flex">
                            <!-- <v-btn-toggle v-model="ac"> -->
                            <v-btn @click="undo"><v-icon>mdi-undo</v-icon></v-btn>
                            <v-btn @click="redo"><v-icon>mdi-redo</v-icon></v-btn>
                            <!-- </v-btn-toggle> -->
                            <v-spacer></v-spacer>
                            <!-- <v-btn-toggle> -->
                            <v-btn @click="saveLayout"><v-icon>mdi-content-save</v-icon></v-btn>
                            <!-- <v-btn @click="exportImage"><v-icon>mdi-export</v-icon></v-btn> -->
                            <v-btn @click="exportVideo" :loading="exporting"><v-icon>mdi-export</v-icon></v-btn>
                            <!-- <v-btn @click="startRecordingHD"><v-icon>mdi-export</v-icon> 2</v-btn> -->
                            <!-- </v-btn-toggle> -->
                        </div>

                        <v-card outlined class="pa-2 mt-2">
                            <canvas id="builder-canvas" ref="builderCanvas" :width="sizes.width/2" :height="sizes.height/2"></canvas>
                        </v-card>
                        <template v-if="projectType == 'dinamico'">



                            <v-slider hide-details v-model="currentTime" :max="videoDuration" step="0.1"
                                class="flex-grow-1" @input="onTimelineChange" />
                            <div class="d-flex align-center">
                                <v-btn @click="togglePlay" icon color="primary" v-if="videoDuration > currentTime">
                                    <v-icon>{{ isPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                                </v-btn>
                                <v-btn @click="restart" icon color="primary" v-else>
                                    <v-icon>mdi-reload</v-icon>
                                </v-btn>
                                <v-btn @click="stop" icon color="primary" :disabled="isPlaying || currentTime == 0">
                                    <v-icon>mdi-stop</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <span class="ml-2">{{ currentTime.toFixed(1) }}s / {{ videoDuration }}s</span>
                            </div>
                        </template>

                    </div>

                    <!-- Coluna só aparece se houver módulo ativo -->
                    <div cols="12" md="3" v-if="activeModule">

                        <v-card v-if="selectedObject && selectedObject.type === 'image'" outlined
                            class="px-2 pt-2 mb-1">
                            <h3>Editar Imagem</h3>

                            <!-- Grayscale -->
                            <v-switch v-model="filtersActive.grayscale" label="Grayscale" @change="updateFilters" />

                            <!-- Sepia -->
                            <v-switch v-model="filtersActive.sepia" label="Sepia" @change="updateFilters" />

                            <!-- Hue -->
                            <v-slider v-model="filtersValues.hue" min="0" max="1" step="0.01" label="Hue"
                                @input="updateFilters" />

                            <!-- Saturação -->
                            <v-slider v-model="filtersValues.saturation" min="-1" max="1" step="0.1" label="Saturação"
                                @input="updateFilters" />

                            <!-- Brilho -->
                            <v-slider v-model="filtersValues.brightness" min="-1" max="1" step="0.1" label="Brilho"
                                @input="updateFilters" />

                            <v-btn small @click="resetFilters">Remover Filtros</v-btn>
                        </v-card>
                        <v-card outlined class="px-2 pt-2 mb-1"
                            v-if="selectedObject && selectedObject.type === 'textbox'">
                            <h3 class="subtitle-1 mb-2">Editar texto</h3>
                            <!-- Botões -->
                            <div class="d-flex justify-space-between">
                                <div class="d-flex align-center mb-2">
                                    <v-btn-toggle multiple v-model="textFormatOptions">
                                        <v-btn small @click="toggleStyle('bold')">
                                            <v-icon small>mdi-format-bold</v-icon>
                                        </v-btn>
                                        <v-btn small @click="toggleStyle('italic')">
                                            <v-icon small>mdi-format-italic</v-icon>
                                        </v-btn>
                                        <v-btn small @click="toggleStyle('underline')">
                                            <v-icon small>mdi-format-underline</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                                <v-btn-toggle v-model="textOptions.textAlign"
                                    @change="applyTextStyle('textAlign', textAlignOptions[textOptions.textAlign])">

                                    <v-btn small>
                                        <v-icon small>mdi-format-align-left</v-icon>
                                    </v-btn>
                                    <v-btn small>
                                        <v-icon small>mdi-format-align-center</v-icon>
                                    </v-btn>

                                    <v-btn small>
                                        <v-icon small>mdi-format-align-right</v-icon>
                                    </v-btn>
                                    <v-btn small>
                                        <v-icon small>mdi-format-align-justify</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                            <v-textarea hide-details rows="3" label="Texto" class="my-3" v-model="activeModule.obj.text"
                                @input="canvas.renderAll()" dense outlined></v-textarea>

                            <!-- Cor -->

                            <v-card outlined class="my-3">
                                <legend class="caption mt-n2 ml-2"
                                    style="background: #fff; padding-left: 2px; padding-right: 2px;">Cor do
                                    texto</legend>


                                <v-color-picker dot-size="17" v-model="textOptions.fill"
                                    @input="applyTextStyle('fill', textOptions.fill)" hide-mode-switch mode="hexa"
                                    swatches-max-height="100"></v-color-picker>


                                <!-- <v-color-picker width="100%" flat hide-mode-switch
                                    class="ma-2"
                                    hide-canvas></v-color-picker> -->
                            </v-card>
                        </v-card>
                        <v-card outlined class="px-2 pt-2 mb-1" v-if="selectedObject">
                            <!-- <v-color-picker width="100%" v-model="textOptions.fill" flat hide-mode-switch
                                @input="applyTextStyle('fill', textOptions.fill)" /> -->

                            <!-- Tamanho -->
                            <v-text-field outlined v-model="textOptions.fontSize" type="number" label="Tamanho da Fonte"
                                @input="applyTextStyle('fontSize', textOptions.fontSize)" />
                            <template v-if="projectType == 'dinamico'">
                                <v-select outlined v-model="effectForm.type" item-value="value" item-text="text" :items="[
                                    { text: 'Nenhum', value: 'none' },
                                    { text: 'Digitando', value: 'typing' },
                                    { text: 'Deslizar esquerda', value: 'slideIn' },
                                    { text: 'Aparecer gradativamente', value: 'fadeIn' },
                                    { text: 'Zoom In', value: 'zoomIn' }]" label="Efeito" @change="applyEffect" />
                                <div class="d-flex">

                                    <!-- </div> v-if="effectForm.type != 'none'"> -->

                                    <v-text-field class="mx-1" outlined v-model.number="effectForm.start"
                                        label="Início (segundos)" type="number" @input="applyEffect" />

                                    <v-text-field outlined v-model.number="effectForm.duration"
                                        label="Duração (segundos)" type="number" @input="applyEffect" />
                                </div>
                            </template>

                        </v-card>
                    </div>
                </v-card>
            </template>
        </div>
    </v-card>
</template>

<script>
import { fabric } from "fabric";
export default {
    props: {
        item: Object,
        sizes: Object
    },
    data() {
        return {
            exporting: false,
            slides: [],
            images: [],
            ac: null,
            ffmpeg: null,
            view: "builder",
            projectType: "dinamico",
            videoDuration: 10,
            currentTime: 0,
            isPlaying: false,
            lastTimestamp: null,
            animationFrame: null,
            selectedObject: null,
            // novo
            effectsConfig: new Map(), // Map<fabric.Object, {type, start, end}>
            activeEffect: null,
            typingInterval: null,
            slideAnimation: null,

            canvas: null,
            allTemplates: [
                { name: "Template 1", bg: "https://tmt-s3-v2.s3.amazonaws.com/builder/templates/template1.png" },
                { name: "Template 2", bg: "https://tmt-s3-v2.s3.amazonaws.com/builder/templates/template2.png" },
                { name: "Template 3", bg: "https://tmt-s3-v2.s3.amazonaws.com/builder/templates/template3.png" },
                { name: "Template 4", bg: "https://tmt-s3-v2.s3.amazonaws.com/builder/templates/template4.png" }
            ],
            templates: [],
            canvasModules: {},
            activeModule: null,
            moduleCounter: 0,
            textColor: "#000000",
            fontSize: 30,
            history: [],
            historyIndex: -1,
            editMode: "object", // "object" ou "selection"
            textOptions: {
                fill: "#000000",
                fontSize: 24,
                fontWeight: "normal",
                fontStyle: "normal",
                underline: false,
                textAlign: "left",
            },
            textAlignOptions: ['left', 'center', 'right', 'justify'],

            textFormatOptions: [],
            filtersActive: {
                grayscale: false,
                sepia: false,
            },
            filtersValues: {
                hue: 0,
                saturation: 0,
                brightness: 0,
            },
            ctx: null

        };
    },
    mounted() {
        this.slides = [
            {
                duration: 5, // segundos
                objects: [/* fabric objs do slide */],
                effectsConfig: new Map()
            },
            {
                duration: 7,
                objects: [/* objs do slide 2 */],
                effectsConfig: new Map()
            }
        ];


        this.canvas = new fabric.Canvas("builder-canvas", {
            selection: true,
            preserveObjectStacking: true,
        });

        if (this.canvas)
            this.ctx = this.canvas.getContext("2d");



        // Converter templates para base64 antes de carregar
        this.convertTemplatesToBase64().then(() => {
            // Carrega o primeiro template automaticamente
            this.loadTemplate(this.templates[0]);
        });

        // Eventos do canvas
        this.canvas.on("object:added", () => this.saveHistory());
        this.canvas.on("object:modified", () => this.saveHistory());
        this.canvas.on("object:removed", () => this.saveHistory());
        this.canvas.on("object:selected", this.onObjectSelected);
        this.canvas.on("selection:cleared", this.onSelectionCleared);

        // Seleção e edição
        this.canvas.on("selection:created", (e) => {
            this.selectedObject = e.target;
            const cfg = this.effectsConfig.get(this.selectedObject) || { type: "none", start: 0, duration: 3 };
            this.effectForm = { ...cfg };
            this.syncTextOptions();
        });
        this.canvas.on("selection:updated", (e) => {
            this.selectedObject = e.target;
            this.syncTextOptions();
        });

        // Duplo clique para editar textos
        this.canvas.on("mouse:dblclick", (opt) => {
            const target = opt.target;
            if (target && target.type === "textbox") {
                this.canvas.setActiveObject(target);
                target.enterEditing();
                target.selectAll();
                setTimeout(() => {
                    target.hiddenTextarea.focus();
                }, 100);
                this.selectModuleByObject(target);
            }
        });

        this.canvas.on("mouse:down", (e) => {
            if (e.target) {
                const mod = Object.values(this.canvasModules).find(m => m.obj === e.target);
                if (mod) this.selectModule(mod);
            } else {
                this.activeModule = null;
            }
        });
    },
    methods: {
        selectModuleByObject(obj) {
            const mod = Object.values(this.canvasModules).find(m => m.obj === obj);
            if (mod) this.selectModule(mod);
        },
        async exportVideoWithSlides() {
            if (!this.slides || this.slides.length === 0) return;

            const targetWidth = this.sizes.width;
            const targetHeight = this.sizes.height;
            const fps = this.sizes.fps;

            // Canvas de exportação
            const exportCanvas = new fabric.StaticCanvas(null, {
                width: targetWidth,
                height: targetHeight
            });

            // 🎥 Prepara MediaRecorder
            const htmlCanvas = exportCanvas.lowerCanvasEl;
            const stream = htmlCanvas.captureStream(fps);
            const chunks = [];
            const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

            recorder.ondataavailable = e => { if (e.data.size > 0) chunks.push(e.data); };
            recorder.onstop = () => {
                const blob = new Blob(chunks, { type: "video/webm" });
                const url = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = "slides-video.webm";
                link.click();

                URL.revokeObjectURL(url);
            };

            recorder.start();

            // Timeline
            let currentSlideIndex = 0;
            let slideTime = 0;
            let lastFrameTime = performance.now();
            const startTime = performance.now();

            const loop = (now) => {
                const slide = this.slides[currentSlideIndex];
                if (!slide) {
                    recorder.stop();
                    return;
                }

                const elapsed = now - lastFrameTime;
                const frameDuration = 1000 / fps;

                if (elapsed >= frameDuration) {
                    slideTime += elapsed / 1000;
                    lastFrameTime = now;

                    // Se terminou o slide → passa para o próximo
                    if (slideTime >= slide.duration) {
                        currentSlideIndex++;
                        slideTime = 0;
                        exportCanvas.clear();

                        if (!this.slides[currentSlideIndex]) {
                            recorder.stop();
                            return;
                        }

                        // Adiciona os objetos do próximo slide
                        this.slides[currentSlideIndex].objects.forEach(obj => {
                            obj.clone(cloned => exportCanvas.add(cloned));
                        });
                    }

                    // Atualiza efeitos do slide atual
                    this.updateSlideByTime(slide, slideTime, exportCanvas);
                }

                requestAnimationFrame(loop);
            };

            requestAnimationFrame(loop);
        },

        updateSlideByTime(slide, time, targetCanvas) {
            slide.objects.forEach(obj => {
                const cfg = slide.effectsConfig.get(obj) || { type: "none" };
                if (cfg.type === "none") return;

                const { start, duration, type } = cfg;
                const progress = (time - start) / duration;

                if (progress < 0) {
                    obj.visible = false;
                    return;
                }

                obj.visible = true;
                const p = Math.min(Math.max(progress, 0), 1);

                if (type === "typing" && obj.text) {
                    if (!obj._originalText) obj._originalText = obj.text;
                    const fullText = obj._originalText;
                    obj.text = fullText.substring(0, Math.floor(fullText.length * p));
                }

                if (type === "slideIn") {
                    if (!obj._finalLeft) obj._finalLeft = obj.left;
                    const startLeft = -obj.width * (obj.scaleX || 1);
                    obj.left = startLeft + (obj._finalLeft - startLeft) * p;
                }

                if (type === "fade") {
                    obj.opacity = p;
                }
            });

            targetCanvas.renderAll();
        },

        async convertTemplatesToBase64() {
            this.templates = []
            console.log('init conversor...')
            const loadImageAsBase64 = (url) => {
                console.log('URL', url)
                return new Promise((resolve) => {
                    const img = new Image();
                    img.crossOrigin = "anonymous"; // evita canvas tainted
                    img.onload = () => {
                        const canvasTemp = document.createElement("canvas");
                        canvasTemp.width = img.width;
                        canvasTemp.height = img.height;
                        const ctx = canvasTemp.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        let type = "image/png";
                        if (url.match(/\.(jpg|jpeg)$/i)) type = "image/jpeg";
                        const base64 = canvasTemp.toDataURL(type);
                        resolve(base64);
                    };

                    img.src = url;
                });
            };

            for (let i = 0; i < this.allTemplates.length; i++) {
                console.log('I', i)
                const tpl = this.allTemplates[i];
                console.log('TPL before', tpl)
                if (!tpl.bg.startsWith("data:")) {
                    // tpl.bg = await loadImageAsBase64(tpl.bg);
                    this.allTemplates[i].base = await loadImageAsBase64(tpl.bg);
                    tpl.bg = await loadImageAsBase64(tpl.bg);
                    console.log('TPL after', tpl)
                }
                console.log('pushing ', tpl)
                this.templates.push(tpl)
            }

            console.log("Templates convertidos para base64:", this.templates);
        },
        loadTemplate(tpl) {
            // Se a imagem já está em base64, usamos diretamente
            const url = tpl.bg;

            fabric.Image.fromURL(
                url,
                (img) => {
                    // Ajusta tamanho para o canvas
                    img.scaleToWidth(this.canvas.width);
                    img.scaleToHeight(this.canvas.height);

                    // Define como background
                    this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas));

                    // Salva histórico
                    this.saveHistory();
                },
                {
                    crossOrigin: "anonymous" // necessário para evitar canvas tainted
                }
            );
        },

        async togglePlay() {
            await this.preloadImages();
            if (this.isPlaying) {
                this.pause();
            } else {
                this.play();
            }
        },
        async restart() {
            this.stop()
            await this.preloadImages();
            this.play()
        },
        async startRecording() {
            await this.preloadImages();
            if (!this.canvas) return;
            this.stop()
            const fps = this.sizes.fps;
            const stream = this.canvas.lowerCanvasEl.captureStream(fps);
            this.chunks = [];
            this.recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

            this.recorder.ondataavailable = e => { if (e.data.size > 0) this.chunks.push(e.data); };
            this.recorder.onstop = () => {
                const blob = new Blob(this.chunks, { type: "video/webm" });
                const url = URL.createObjectURL(blob);
                console.log('URL', url)
                const link = document.createElement("a");
                link.href = url;
                link.download = "slide-video.webm";
                link.click();

                URL.revokeObjectURL(url);
            };

            this.recorder.start();
            this.play(); // dispara o play junto
        },

        stopRecording() {
            if (this.recorder && this.recorder.state !== "inactive") {
                this.recorder.stop();
            }
            this.pause();
        },



        async preloadImages() {
            if (!this.images) return;

            const promises = this.images.map(img => {
                return new Promise((resolve) => {
                    if (img.ready) return resolve();

                    const image = new Image();
                    image.src = img.src; // base64 ou URL
                    image.onload = () => {
                        img.el = image;
                        img.ready = true;
                        resolve();
                    };
                    image.onerror = () => resolve(); // ignora erros
                });
            });

            await Promise.all(promises);
            console.log("Todas as imagens foram carregadas");
        },

        play() {
            if (this.isPlaying) return;
            this.isPlaying = true;

            // sincroniza startTime com currentTime (para quando o usuário pausou e arrastou o slider)
            this.startTime = performance.now() - this.currentTime * 1000;

            const step = (timestamp) => {
                if (!this.isPlaying) return;

                const elapsed = (timestamp - this.startTime) / 1000; // segundos
                this.currentTime = Math.min(elapsed, this.videoDuration);

                this.updateCanvasByTime(this.currentTime);

                if (this.currentTime < this.videoDuration) {
                    this.animationFrame = requestAnimationFrame(step);
                } else {
                    this.pause();
                }
            };

            this.animationFrame = requestAnimationFrame(step);
        },

        pause() {
            this.isPlaying = false;
            if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        },
        // updateCanvasByTime(time) {
        //     if (!this.ctx || !this.canvas) return;

        //     const ctx = this.ctx;
        //     ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        //     // Desenha todas as imagens carregadas
        //     if (this.images) {
        //         this.images.forEach(img => {
        //             if (img.ready) {
        //                 this.applySlideEffect(ctx, img, time);
        //             }
        //         });
        //     }

        //     // Desenha textos
        //     if (this.texts) {
        //         this.texts.forEach(txt => {
        //             this.applyTextEffect(ctx, txt, time);
        //         });
        //     }
        // },
        applySlideEffect(ctx, img, time) {
            const progress = Math.min(1, Math.max(0, (time - img.startTime) / img.duration));
            ctx.save();
            ctx.globalAlpha = progress; // fade-in suave
            ctx.drawImage(img.el, img.x, img.y, img.width, img.height);
            ctx.restore();
        },
        applyTextEffect(ctx, txt, time) {
            const progress = Math.min(1, Math.max(0, (time - txt.startTime) / txt.duration));

            ctx.save();
            ctx.globalAlpha = progress;
            ctx.font = `${txt.size}px ${txt.font || "Arial"}`;
            ctx.fillStyle = txt.color || "#fff";
            ctx.fillText(txt.text, txt.x, txt.y);
            ctx.restore();
        },
        stop() {
            this.pause()
            this.startTime = 0
            this.currentTime = 0
            this.animationFrame = requestAnimationFrame(0);
        },
        animateTimeline(timestamp) {
            if (!this.isPlaying) return;

            if (!this.lastTimestamp) this.lastTimestamp = timestamp || performance.now();
            const now = timestamp || performance.now();
            const delta = (now - this.lastTimestamp) / 1000; // segundos
            this.lastTimestamp = now;

            this.currentTime += delta;

            if (this.currentTime >= this.videoDuration) {
                this.currentTime = this.videoDuration;
                this.pauseTimeline();
            }

            // Atualiza o canvas com base no tempo
            this.updateCanvasByTime(this.currentTime);

            // Atualiza o slider automaticamente porque currentTime é reativo
            this.animationFrame = requestAnimationFrame(this.animateTimeline);



        },

        onTimelineChange() {
            // Quando o usuário arrasta o slider manualmente
            this.updateCanvasByTime(this.currentTime);
        },
        seekTimeline() {
            this.updateCanvasByTime(this.currentTime);
            // se estiver tocando, reinicia startTime para continuar do ponto atual
            if (this.isPlaying) this.startTime = performance.now() - this.currentTime * 1000;
        },


        // Atualiza canvas clone por tempo
        updateCanvasByTime(time) {
            if (!this.canvas) return;

            this.canvas.getObjects().forEach((obj) => {
                const cfg = this.effectsConfig.get(obj);
                if (!cfg || cfg.type === "none") {
                    obj.visible = true;
                    return;
                }

                const { type, start, duration } = cfg;
                const progress = (time - start) / duration;

                obj.visible = progress >= 0;

                if (type === "fadeIn") {
                    const p = Math.min(Math.max(progress, 0), 1);
                    obj.opacity = p;
                }

                if (type === "slideIn") {
                    if (!obj._finalLeft) obj._finalLeft = obj.left;
                    const startLeft = -obj.width * (obj.scaleX || 1);
                    const p = Math.min(Math.max(progress, 0), 1);
                    obj.left = startLeft + (obj._finalLeft - startLeft) * p;
                }

                if (type === "typing" && obj.type == 'textbox') {
                    const fullText = obj._originalText || obj.text;
                    if (!obj._originalText) obj._originalText = fullText;
                    const chars = Math.min(Math.floor(fullText.length * progress), fullText.length);
                    obj.text = fullText.substring(0, chars);
                }

                if (type === "zoomIn" && obj.type === "image") {
                    const p = Math.min(Math.max(progress, 0), 1);
                    const targetScale = obj._targetScale || obj.scaleX;
                    obj.scaleX = obj.scaleY = p * targetScale;
                }
            });

            this.canvas.renderAll();
        },
        applyEffect() {
            if (!this.selectedObject) return;

            this.effectsConfig.set(this.selectedObject, {
                type: this.effectForm.type,
                start: this.effectForm.start,
                duration: this.effectForm.duration
            });
        },

        updateFilters() {
            if (!this.selectedObject || this.selectedObject.type !== "image") return;

            const filters = [];

            if (this.filtersActive.grayscale) {
                filters.push(new fabric.Image.filters.Grayscale());
            }
            if (this.filtersActive.sepia) {
                filters.push(new fabric.Image.filters.Sepia());
            }
            if (this.filtersValues.hue !== 0) {
                filters.push(new fabric.Image.filters.HueRotation({ rotation: this.filtersValues.hue }));
            }
            if (this.filtersValues.saturation !== 0) {
                filters.push(new fabric.Image.filters.Saturation({ saturation: this.filtersValues.saturation }));
            }
            if (this.filtersValues.brightness !== 0) {
                filters.push(new fabric.Image.filters.Brightness({ brightness: this.filtersValues.brightness }));
            }

            this.selectedObject.filters = filters;
            this.selectedObject.applyFilters();
            this.canvas.renderAll();
        },

        resetFilters() {
            if (!this.selectedObject || this.selectedObject.type !== "image") return;
            this.selectedObject.filters = [];
            this.selectedObject.applyFilters();
            this.canvas.renderAll();

            // reset UI
            this.filtersActive = { grayscale: false, sepia: false };
            this.filtersValues = { hue: 0, saturation: 0, brightness: 0 };
        },
        syncTextOptions() {
            if (this.selectedObject && this.selectedObject.type === "textbox") {
                this.textOptions = {
                    fill: this.selectedObject.fill || "#000000",
                    fontSize: this.selectedObject.fontSize || 24,
                    fontWeight: this.selectedObject.fontWeight || "normal",
                    fontStyle: this.selectedObject.fontStyle || "normal",
                    underline: this.selectedObject.underline || false,
                    textAlign: this.selectedObject.textAlign || "left",
                };
            }
        },
        applyTextStyle(prop, value) {
            if (!this.selectedObject || this.selectedObject.type !== "textbox") return;

            const hasSelection =
                this.selectedObject.selectionStart !== this.selectedObject.selectionEnd;

            if (!hasSelection) {
                // aplica no textbox inteiro
                this.selectedObject.set(prop, value);
            } else {
                // aplica só no trecho selecionado
                const styleOptions = {};
                styleOptions[prop] = value;
                this.selectedObject.setSelectionStyles(styleOptions);
            }

            this.canvas.renderAll();
        },

        toggleStyle(style) {
            if (!this.selectedObject || this.selectedObject.type !== "textbox") return;

            const hasSelection =
                this.selectedObject.selectionStart !== this.selectedObject.selectionEnd;

            if (!hasSelection) {
                // aplica no objeto inteiro
                if (style === "bold") {
                    this.selectedObject.set(
                        "fontWeight",
                        this.selectedObject.fontWeight === "bold" ? "normal" : "bold"
                    );
                } else if (style === "italic") {
                    this.selectedObject.set(
                        "fontStyle",
                        this.selectedObject.fontStyle === "italic" ? "normal" : "italic"
                    );
                } else if (style === "underline") {
                    this.selectedObject.set("underline", !this.selectedObject.underline);
                }
            } else {
                // aplica só na seleção
                const styleOptions = {};
                if (style === "bold") {
                    styleOptions.fontWeight =
                        this.selectedObject.getSelectionStyles().some((s) => s.fontWeight === "bold")
                            ? "normal"
                            : "bold";
                } else if (style === "italic") {
                    styleOptions.fontStyle =
                        this.selectedObject.getSelectionStyles().some((s) => s.fontStyle === "italic")
                            ? "normal"
                            : "italic";
                } else if (style === "underline") {
                    styleOptions.underline = !this.selectedObject
                        .getSelectionStyles()
                        .some((s) => s.underline);
                }
                this.selectedObject.setSelectionStyles(styleOptions);
            }

            this.canvas.renderAll();
        },

        isActiveStyle() {
            const actived = []
            if (!this.selectedObject || this.selectedObject.type !== "textbox") this.textFormatOptions = actived;

            const hasSelection =
                this.selectedObject.selectionStart !== this.selectedObject.selectionEnd;

            if (!hasSelection) {
                if (this.selectedObject.fontWeight === "bold")
                    actived.push(0)
                if (this.selectedObject.fontStyle === "italic")
                    actived.push(1)
                if (this.selectedObject.underline)
                    actived.push(2)
            } else {
                const styles = this.selectedObject.getSelectionStyles();
                if (styles.some((s) => s.fontWeight === "bold")) actived.push(0)
                if (styles.some((s) => s.fontStyle === "italic")) actived.push(1)
                if (styles.some((s) => s.underline)) actived.push(2)
            }
            this.textFormatOptions = actived;
        },


        async startRecordingHD() {
            if (!this.canvas) return;

            const targetWidth = this.sizes.width;
            const targetHeight = this.sizes.height;
            const fps = this.sizes.fps;

            // Cria canvas clone HD
            const exportCanvas = new fabric.StaticCanvas(null, {
                width: targetWidth,
                height: targetHeight,
            });

            const scaleX = targetWidth / this.canvas.width;
            const scaleY = targetHeight / this.canvas.height;

            // Clona background
            if (this.canvas.backgroundImage) {
                this.canvas.backgroundImage.clone((bg) => {
                    bg.scaleX = (this.canvas.backgroundImage.scaleX || 1) * scaleX;
                    bg.scaleY = (this.canvas.backgroundImage.scaleY || 1) * scaleY;
                    exportCanvas.setBackgroundImage(bg, exportCanvas.renderAll.bind(exportCanvas));
                });
            }

            // Clona objetos
            this.canvas.getObjects().forEach(obj => {
                obj.clone(clonedObj => {
                    clonedObj.set({
                        left: obj.left * scaleX,
                        top: obj.top * scaleY,
                        scaleX: (obj.scaleX || 1) * scaleX,
                        scaleY: (obj.scaleY || 1) * scaleY,
                    });
                    exportCanvas.add(clonedObj);
                });
            });

            // Preparar MediaRecorder
            const htmlCanvas = exportCanvas.lowerCanvasEl;
            const stream = htmlCanvas.captureStream(fps);
            const chunks = [];
            const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

            recorder.ondataavailable = e => { if (e.data.size > 0) chunks.push(e.data); };
            recorder.onstop = () => {
                const blob = new Blob(chunks, { type: "video/webm" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `video-${this.sizes.width}x${this.sizes.height}.webm`;
                link.click();
                URL.revokeObjectURL(url);
            };

            recorder.start();

            // Chama o play original, mas passando o canvas HD para renderizar
            const originalCanvas = this.canvas; // salva referência
            this.canvas = exportCanvas;         // temporariamente usa canvas HD
            await this.play();                  // play é assíncrono? Se não, remove await
            this.canvas = originalCanvas;       // restaura canvas original
            recorder.stop();

        },

        // ==== E F F E C T S ======

        setTextEffect(effectType) {
            if (!this.selectedObject || this.selectedObject.type !== "textbox") return;

            // exemplo: todos começam no 0s e terminam em 5s
            this.effectsConfig.set(this.selectedObject, {
                type: effectType,
                start: 0,
                end: 5
            });

            this.canvas.renderAll();
        },
        async exportVideo() {
            if (!this.canvas) return;
            this.exporting = true
            const targetWidth = this.sizes.width;
            const targetHeight = this.sizes.height;
            const fps = this.sizes.fps;
            const duration = this.videoDuration;
            const totalFrames = Math.round(duration * fps);
            let frameCount = 0
            const exportCanvas = new fabric.StaticCanvas(null, {
                width: targetWidth,
                height: targetHeight
            });

            const scaleX = targetWidth / this.canvas.width;
            const scaleY = targetHeight / this.canvas.height;

            // 1) Clona background (aguarda)
            await new Promise((resolve) => {
                if (!this.canvas.backgroundImage) return resolve();
                this.canvas.backgroundImage.clone((bg) => {
                    bg.scaleX = (this.canvas.backgroundImage.scaleX || 1) * scaleX;
                    bg.scaleY = (this.canvas.backgroundImage.scaleY || 1) * scaleY;
                    exportCanvas.setBackgroundImage(bg, exportCanvas.renderAll.bind(exportCanvas));
                    resolve();
                });
            });

            // 2) Clona objetos (aguarda todos os clones)
            const clonedObjects = []; // { obj: clonedObj, original: originalObj }
            const clonePromises = this.canvas.getObjects().map(original => {
                return new Promise((resolve) => {
                    original.clone((cloned) => {
                        // aplica escala/posicionamento proporcional
                        cloned.set({
                            left: original.left * scaleX,
                            top: original.top * scaleY,
                            scaleX: (original.scaleX || 1) * scaleX,
                            scaleY: (original.scaleY || 1) * scaleY,
                            opacity: original.opacity ?? 1,
                            visible: true
                        });

                        // preserva propriedades de estado necessárias
                        if (original._finalLeft) cloned._finalLeft = original._finalLeft;
                        if (original._targetScale) cloned._targetScale = original._targetScale;

                        // preserva texto original e inicializa texto do clone quando houver efeito typing
                        const cfg = this.effectsConfig.get(original);
                        const hasTyping = cfg
                            ? (Array.isArray(cfg) ? cfg.some(e => e.type === 'typing') : cfg.type === 'typing')
                            : false;

                        if (original.text !== undefined) {
                            // guarda texto completo para referência
                            cloned._originalText = original._originalText || original.text || "";
                            if (hasTyping) {
                                // inicia vazio para que o typing comece do nada
                                cloned.set('text', '');
                            } else {
                                // copia o texto completo se não houver typing
                                cloned.set('text', cloned._originalText);
                            }
                        }

                        // copia filtros de imagem (se houver)
                        if (original.type === 'image' && original.filters) {
                            cloned.filters = original.filters;
                            // applyFilters pode ser necessária para que a imagem apareça corretamente
                            cloned.applyFilters();
                        }

                        exportCanvas.add(cloned);
                        clonedObjects.push({ obj: cloned, original });
                        resolve();
                    });
                });
            });

            await Promise.all(clonePromises);
            // Inicializa objetos no estado inicial
            clonedObjects.forEach(({ obj, original }) => {
                let cfg = this.effectsConfig.get(original);
                if (!cfg) return;
                if (!Array.isArray(cfg)) cfg = [cfg];

                cfg.forEach(effect => {
                    if (effect.type === 'fadeIn') obj.opacity = 0;
                    if (effect.type === 'slideIn') {
                        const startLeft = -obj.width * (obj.scaleX || 1);
                        obj.left = startLeft;
                    }
                    if (effect.type === 'zoomIn') {
                        obj.scaleX = obj.scaleY = 0.001;
                    }
                    if (effect.type === 'typing' && obj._originalText) {
                        obj.set('text', '');
                    }
                });
            });
            exportCanvas.renderAll();

            // 3) Prepara MediaRecorder (após clones prontos)
            const htmlCanvas = exportCanvas.lowerCanvasEl;
            const stream = htmlCanvas.captureStream(fps);
            const chunks = [];
            const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

            recorder.ondataavailable = e => { if (e.data && e.data.size > 0) chunks.push(e.data); };
            recorder.onstop = () => {
                const blob = new Blob(chunks, { type: "video/webm" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `video-${this.sizes.width}x${this.sizes.height}.webm`;
                a.click();
                URL.revokeObjectURL(url);
            };

            recorder.start();

            // 4) Timeline com base no startTime (evita acumular erro)
            const startTime = performance.now();

            const frame = (now) => {
                const currentTime = Math.min((now - startTime) / 1000, duration); // segundos

                // Atualiza todos os clones usando effectsConfig (original é a chave)
                clonedObjects.forEach(({ obj, original }) => {
                    let cfg = this.effectsConfig.get(original);

                    // Se não houver cfg, restaurar estado original (texto/opacidade)
                    if (!cfg) {
                        if (original.text !== undefined) {
                            // garante texto completo
                            obj.set('text', original._originalText || original.text || '');
                        }
                        obj.opacity = original.opacity ?? 1;
                        if (obj.type === 'image' && obj.filters) obj.applyFilters();
                        return;
                    }

                    // garante array
                    if (!Array.isArray(cfg)) cfg = [cfg];

                    // aplica múltiplos efeitos
                    cfg.forEach(effect => {
                        const { type, start = 0, duration: dur = 1 } = effect;
                        const rawProgress = (currentTime - start) / (dur || 1);
                        const progress = rawProgress;
                        const p = Math.min(Math.max(progress, 0), 1);

                        if (progress < 0) return; // ainda não começou

                        if (type === 'fadeIn') {
                            obj.opacity = p;
                        }

                        if (type === 'slideIn') {
                            if (!obj._finalLeft) obj._finalLeft = (original._finalLeft ?? (original.left * scaleX));
                            const startLeft = -obj.width * (obj.scaleX || 1);
                            obj.left = startLeft + (obj._finalLeft - startLeft) * p;
                        }

                        if (type === 'zoomIn') {
                            if (!obj._targetScale) obj._targetScale = original._targetScale ?? obj.scaleX;
                            obj.scaleX = obj.scaleY = p * obj._targetScale;
                        }

                        if (type === 'typing') {
                            // texto: usar `_originalText` que definimos no clone
                            const fullText = obj._originalText || (original._originalText || original.text || '');
                            const chars = Math.min(Math.floor(fullText.length * p), fullText.length);
                            // use set('text', ...) para atualizar corretamente o textbox
                            obj.set('text', fullText.substring(0, chars));
                        }
                    });

                    // reaplica filtros (imagem)
                    if (obj.type === 'image' && obj.filters) obj.applyFilters();
                });

                exportCanvas.renderAll();
                frameCount++;

                if (currentTime < duration) {
                    requestAnimationFrame(frame);
                } else {
                    // garante frame final e para gravação
                    // (já renderamos com currentTime = duration por min acima)
                    this.exporting = false
                    recorder.stop();
                }
                // if (frameCount < totalFrames) {
                //     requestAnimationFrame(frame);
                // } else {
                //     // 🔹 Garante repetição do último frame até preencher a duração
                //     const repeat = totalFrames - frameCount;
                //     for (let i = 0; i < repeat; i++) {
                //         exportCanvas.renderAll();
                //     }
                //     this.exporting = false;
                //     recorder.stop();
                // }
            };

            requestAnimationFrame(frame);
        },

        clearActiveEffect() {
            if (this.typingInterval) {
                clearInterval(this.typingInterval);
                this.typingInterval = null;
            }
        },
        // ===== Módulos =====
        addTextModule() {
            const id = `mod-${this.moduleCounter++}`;
            const textbox = new fabric.Textbox("Novo Texto", {
                left: 100,
                top: 50,
                fontSize: this.fontSize,
                fontFamily: "Arial",
                fill: this.textColor,
                editable: true,      // 🔑 deve ser true
                hasControls: true,
                selectable: true,
            });
            this.canvas.add(textbox);
            this.canvasModules[id] = { id, type: "textbox", name: "Texto", obj: textbox };
            this.selectModule(this.canvasModules[id]);
        },
        triggerImageUpload() { this.$refs.fileInput.click(); },
        onImageUpload(e) {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (f) => {
                const id = `mod-${this.moduleCounter++}`;
                fabric.Image.fromURL(f.target.result, (img) => {
                    img.set({ left: 100, top: 100, scaleX: 0.5, scaleY: 0.5, hasControls: true, selectable: true });
                    this.canvas.add(img);
                    this.canvasModules[id] = { id, type: "image", name: file.name, obj: img };
                    this.selectModule(this.canvasModules[id]);
                });
            };
            reader.readAsDataURL(file);
        },
        selectModule(mod) {
            this.activeModule = mod;
            this.canvas.setActiveObject(mod.obj);
            if (mod.type === "textbox") mod.obj.set({ editable: true });
            Object.values(this.canvasModules).forEach(m => {
                if (m.id !== mod.id && m.type === "textbox") m.obj.set({ editable: false });
            });
            this.canvas.renderAll();
        },
        removeModule(mod) {
            this.canvas.remove(mod.obj);
            delete this.canvasModules[mod.id];
            if (this.activeModule && this.activeModule.id === mod.id) this.activeModule = null;
            this.canvas.renderAll();
        },

        // ===== Módulo selecionado =====
        onObjectSelected(e) {
            const obj = e.target;
            const mod = Object.values(this.canvasModules).find(m => m.obj === obj);
            if (mod) this.selectModule(mod);
        },
        onSelectionCleared() {
            if (this.activeModule && this.activeModule.type === "textbox") this.activeModule.obj.set({ editable: false });
            this.activeModule = null;
        },
        updateTextColor() {
            if (this.activeModule && this.activeModule.type === "textbox") {
                this.activeModule.obj.set("fill", this.textColor);
                this.canvas.renderAll();
            }
        },
        updateFontSize() {
            if (this.activeModule && this.activeModule.type === "textbox") {
                this.activeModule.obj.set("fontSize", this.fontSize);
                this.canvas.renderAll();
            }
        },

        // ===== Undo / Redo =====
        saveHistory() {
            const json = JSON.stringify(this.canvas.toJSON());
            // remove estados futuros se refazer após desfazer
            this.history = this.history.slice(0, this.historyIndex + 1);
            this.history.push(json);
            this.historyIndex++;
        },
        undo() {
            if (this.historyIndex <= 0) return;
            this.historyIndex--;
            this.canvas.loadFromJSON(this.history[this.historyIndex], () => this.canvas.renderAll());
        },
        redo() {
            if (this.historyIndex >= this.history.length - 1) return;
            this.historyIndex++;
            this.canvas.loadFromJSON(this.history[this.historyIndex], () => this.canvas.renderAll());
        },

        // ===== Salvar layout =====
        async saveLayout() {
            if (!this.canvas) return;
            this.exporting = true;

            try {
                const json = this.canvas.toJSON();

                const image = await this.exportImage(); // aguarda a exportação
                console.log('IMAGE', image)
                this.$axios.put(`builder/template`, { image, ...this.item, canvasObject: json });        // só dispara depois
                console.log("Upload concluído!");
            } catch (err) {
                console.error("Erro ao exportar:", err);
            } finally {
                this.exporting = false;
            }
        },
        async savesLayout() {
            const json = this.canvas.toJSON();
            console.log("Layout salvo:", json);
            const form = {
                ...this.item,
                imageSample: await this.exportImage(),
                canvasObject: json
            }
            console.log('Form', form)
            this.$axios.put(`builder/template`, form)
        },

        async exportImage() {
            const targetWidth = this.sizes.width;
            const targetHeight = this.sizes.height;

            // Clonar o canvas
            const cloned = new fabric.StaticCanvas(null, {
                width: targetWidth,
                height: targetHeight,
            });

            // Escala proporcional
            const scaleX = targetWidth / this.canvas.width;
            const scaleY = targetHeight / this.canvas.height;

            // Clona cada objeto para o novo canvas
            this.canvas.getObjects().forEach(obj => {
                obj.clone((clonedObj) => {
                    clonedObj.set({
                        left: obj.left * scaleX,
                        top: obj.top * scaleY,
                        scaleX: (obj.scaleX || 1) * scaleX,
                        scaleY: (obj.scaleY || 1) * scaleY,
                    });
                    cloned.add(clonedObj);
                    cloned.renderAll();
                });
            });

            // Clona e ajusta background
            if (this.canvas.backgroundImage) {
                this.canvas.backgroundImage.clone((bg) => {
                    bg.scaleX = (this.canvas.backgroundImage.scaleX || 1) * scaleX;
                    bg.scaleY = (this.canvas.backgroundImage.scaleY || 1) * scaleY;
                    cloned.setBackgroundImage(bg, cloned.renderAll.bind(cloned));
                });
            }

            // Pequeno timeout para garantir que tudo seja renderizado
                const dataURL = cloned.toDataURL({
                    format: 'jpeg',
                    quality: 1.0, // 100%
                });
                return dataURL

                // Baixar imagem
                // const link = document.createElement('a');
                // link.href = dataURL;
                // link.download = 'imagem-1920x1080.jpg';
                // link.click();
        },



    }
};
</script>
<style>
.templates {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 5px;
}

.templates>* {
    box-sizing: border-box;
    max-height: 100%;
    max-width: 100%;
}

.templates .v-img {
    box-sizing: border-box;
    max-height: 100%;
    max-width: 100%;
}

.-grid-columns {
    display: grid;
    grid-template-columns: 264px 2fr 1fr;
    column-gap: 15px;
}
</style>
